import { Chip, Tooltip } from '@mui/material';
import { 
  Event as EventIcon,
  PlayArrow as PlayArrowIcon,
  Repeat as RepeatIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import { format, parseISO } from 'date-fns';

const ScheduleBadge = ({ config }) => {
  let label = '';
  let tooltip = '';
  let icon = <ScheduleIcon fontSize="small" />;
  
  if (config.mode === 'RECURRING') {
    label = 'Recurring';
    tooltip = `Cron: ${config.cronExpression}`;
    icon = <RepeatIcon fontSize="small" />;
  } else if (config.mode === 'ONE_TIME') {
    const date = parseISO(config.scheduledTime);
    label = 'One-time';
    tooltip = `${format(date, 'PPP')} at ${format(date, 'p')}`;
    icon = <EventIcon fontSize="small" />;
  } else {
    label = 'On Demand';
    tooltip = 'Runs only when manually triggered';
    icon = <PlayArrowIcon fontSize="small" />;
  }
  
  return (
    <Tooltip title={tooltip}>
      <Chip 
        icon={icon}
        label={label}
        size="small"
        variant="outlined"
      />
    </Tooltip>
  );
};

export default ScheduleBadge;